<template>
  <div>
    <div class="header page-header">
      <div >CLIENTS</div>
      <p>Edit client</p>
    </div>
    <div class="card">
      <div class="form">
        <div class="form__group form__group--spaced">
          <label>Edit Client</label>
          <input
            placeholder="Type client name"
            class="input input__round input--users-checked"
            style="width: 100%; max-width: 350px"
            v-model="client.name"
          >
        </div>
        <div class="form__group form__group--spaced">
            <select
                class="input input__round input__select"
                style="width: 100%; max-width: 350px"
                v-model="client.country_code"
            >
                <option v-for="(country, code) in countries" :value="code">{{ country }}</option>
            </select>
        </div>
      </div>
      <div v-if="error.length>0" class="errors-wrapper">
        <ul v-for="err in error" :key="err">
          <li class="error-item">{{err}}</li>
        </ul>
      </div>
      <div class="form__actions">
        <Button
          text="Save"
          class="btn btn__primary"
          style="margin-left: auto; display: block"
          @on-click="editClient"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Button from "../partials/Button.vue";
import * as api from "./api.js";

export default {
  name: "EditClient",
  components: {
    Button
  },
  created: async function() {
    this.client = await api.fetchClient(this.$route.params.id);
    document.title = this.client.name + ' | PayGate Invoice'
    this.fetchCountries();
  },
  methods: {
    fetchCountries: async function() {
        this.countries = await api.fetchCountries({});
    },
    editClient: async function() {
      this.error = [];
      if (this.client.name.length < 1) {
        this.error.push("Name is required");
    } else if(this.client.country_code.length < 1) {
        this.error.push("Country code is required");
    } else {
        let response;
        this.loading = true;
        this.error = [];
        try {
          response = await api.editClient(this.client);
          this.loading = false;
          this.$toasted.success("Client edited successfully", {
            className: "success-toast"
          });
          this.$router.push("/dashboard/clients");
        } catch (e) {
          this.loading = false;
          this.error = "error";
          let err_msg = "Something went wrong";
          Object.keys(e.response.data.errors).map(
            key => (err_msg = e.response.data.errors[key][0])
          )
          this.$toasted.error(err_msg, { className: "error-toast" });
        }
      }
    }
  },
  data() {
    return {
      client: {},
      error: [],
      countries: [],
      loading: false
    };
  }
};
</script>

<style lang="scss" scoped>
.errors-wrapper {
  margin-left: 30px;
  margin-top: 20px;
  font-family: Montserrat-Regular;
}
.error-item {
  color: red;
  opacity: 0.7;
  font-family: Montserrat-SemiBold;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
</style>
